// extracted by mini-css-extract-plugin
export var colorSquare = "_rd-0";
export var danger = "_rd-5";
export var lightPink = "_rd-8";
export var neutralBlue = "_rd-7";
export var neutralYellow = "_rd-6";
export var normal = "_rd-1";
export var primary = "_rd-2";
export var primaryLight = "_rd-3";
export var solidBlack = "_rd-g";
export var solidGreen = "_rd-b";
export var solidLightBlue = "_rd-d";
export var solidNavy = "_rd-c";
export var solidOrange = "_rd-f";
export var solidPink = "_rd-e";
export var solidRed = "_rd-9";
export var solidYellow = "_rd-a";
export var success = "_rd-4";